import SuggestionsDropdown from '@finn-no/suggestions-dropdown';
import el from '@finn-no/create-element';

export default {
    dependencies: ['$element', 'xhrservice', 'sitesettings', 'radio'],
    callable(input, xhr, sitesettings, radio) {
        const URL = `${sitesettings.wwwSite}/search/autocomplete/xhr`;
        const SEARCH_KEY = input.getAttribute('data-auto-suggest-key');
        const options = {
            dropdownClass: 'man',
            selectedClass: 'bg-ice',
            onsubmit(item) {
                input.value = item;

                const changeEvent = new Event('change', {
                    cancelable: true,
                    bubbles: true,
                });
                input.dispatchEvent(changeEvent);
            },
        };
        const suggestionsDropdown = new SuggestionsDropdown(
            input,
            fetchSuggestions,
            abort,
            options
        );
        let canceler;

        radio('filters.hide-on-scroll').subscribe(() =>
            suggestionsDropdown.hide()
        );

        function fetchSuggestions(term, onsuccess) {
            // Turn e.g. "&amp;" into "&"
            // TODO(davidh): this is both ugly and temporary, remove when
            // we get correct data from the endpoint.
            const ele = document.createElement('span');
            function dereferenceReferences(text) {
                ele.innerHTML = text;
                return ele.textContent;
            }

            function formatResponse(response) {
                if (response) {
                    return response.map(item =>
                        dereferenceReferences(item.suggest)
                    );
                } else {
                    return [];
                }
            }

            abort();
            canceler = xhr.canceler();

            xhr
                .request({
                    url: URL,
                    data: {
                        responseType: 'jsonp',
                        allowZeroHits: true,
                        rows: 6,
                        searchKey: SEARCH_KEY,
                        term,
                    },
                    type: 'jsonp',
                    canceler,
                })
                .then(e => {
                    canceler = null;
                    return e;
                })
                .then(formatResponse)
                .then(items => {
                    // The first item is the same as the input value, just remove it
                    if (items.length) {
                        items.shift();
                    }

                    if (items.length === 0) {
                        suggestionsDropdown.hide();
                        return;
                    }

                    return onsuccess(render(items));
                });
        }

        function abort() {
            if (canceler) {
                canceler();
            }
        }

        function render(items) {
            return el(
                'ul.mhn.dropdown',
                { style: 'cursor: pointer;' },
                items.map(item => el('li.dropdown-item.phm.pvs', null, item))
            );
        }

        input.addEventListener('focus', () => {
            // This is a workaround for iOS 8, where the input can be completely obscured.
            // 50 ms was to little, trying 100
            if (input.scrollIntoViewIfNeeded) {
                setTimeout(() => input.scrollIntoViewIfNeeded(), 100);
            }
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/marketAutoSuggest.js